import { render, staticRenderFns } from "./Airlines.vue?vue&type=template&id=a72370f4&"
import script from "./Airlines.vue?vue&type=script&lang=js&"
export * from "./Airlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports